<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<ng-container *ngIf="visible; else showNumber">
	<h1>{{ locale.translations['user']['user-profile']['n244'] }}</h1>

	<form [formGroup]="form">
		<div class="mdc-layout-grid__inner">
			<div class="mdc-layout-grid__cell--span-12">
				<div class="container" fxLayout="row" fxLayout.xs="row" fxLayoutWrap>
					<mat-form-field fxFlex="10" appearance="standard" hideRequiredMarker>
						<mat-label></mat-label>
						<mat-select formControlName="phonePrefix">
							<mat-select-trigger>
								<span>{{ form.controls.phonePrefix.value }}</span>
							</mat-select-trigger>

							<input class="search_feild" placeholder="Search" (keyup)="onKey($event.target.value)" />

							<mat-option *ngFor="let prefix of filterselectedCountryPrefix" (click)="onSelect(prefix.dial_code)" [value]="prefix.dial_code">
								{{ prefix.flag }} {{ prefix.name }} ({{ prefix.dial_code }})
							</mat-option>
						</mat-select>
					</mat-form-field>

					<mat-form-field class="phone_wrap" appearance="standard" hideRequiredMarker>
						<mat-label>{{ locale.translations['user']['user-profile']['change-phone']['n245'] }}</mat-label>

						<input
							#phoneInput
							matInput
							required
							dir="ltr"
							type="tel"
							pattern="[0-9]{0,}"
							minlength="10"
							maxlength="15"
							(keyup)="onKeyUp('altPhone')"
							(focus)="phoneInput.setSelectionRange(phoneInput.value.length, phoneInput.value.length)"
							(keypress)="isNumberKey($event)"
							[ngStyle]="{ 'text-align': locale.lang === 'en' ? 'left' : 'right' }"
							formControlName="altPhone"
						/>

						<mat-error *ngIf="!form.get('altPhone').valid">
							{{ locale.translations['logup']['signup']['n231'] }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="container">
					<button
						fxflex="90"
						class="btn btn-default"
						mat-flat-button
						(click)="onSubmit()"
						type="submit"
						color="primary"
						[disabled]="!form.valid || loading || this.form.controls['altPhone'].value.length == '1'"
					>
						{{ locale.translations['logup']['n287'] }}
					</button>
				</div>
			</div>
		</div>
	</form>
</ng-container>

<ng-template #showNumber>
	<p>
		{{ locale.translations['user']['user-verify']['n233'] }}
		<br />

		<span dir="ltr">{{ this.body.phone }}</span>
	</p>

	<p>
		{{ locale.translations['user']['user-verify']['n234'] }}
	</p>
	<div class="mdc-layout-grid__inner">
		<div class="mdc-layout-grid__cell--span-12">
			<form [formGroup]="otpForm">
				<mat-form-field appearance="standard" hideRequiredMarker>
					<mat-label>{{ locale.translations['user']['user-verify']['n235'] }}</mat-label>

					<input matInput formControlName="otp" (keypress)="isNumberKey($event)" minlength="6" maxlength="6" [(ngModel)]="otp" />
				</mat-form-field>

				<span style="height: 1em">
					<a class="cursor-pointer" (click)="resendOTP()" *ngIf="showResendOTP">{{ locale.translations['user']['user-verify']['n236'] }}</a>

					<span *ngIf="!showResendOTP" class="showResendOTPTimer">
						<div class="spinner preserve">
							<mat-progress-spinner mode="determinate" [value]="(showResendOTPTimer / 30) * 100" diameter="20"></mat-progress-spinner>
						</div>

						<span>{{ showResendOTPTimer }}</span>
					</span>
				</span>

				<div class="mdc-layout-grid__cell--span-12">
					<button mat-flat-button color="primary" (click)="onUpdate()" [disabled]="loading || !otpForm.valid">
						{{ locale.translations['logup']['n287'] }}
					</button>
				</div>
			</form>

			<div id="sign-in-button"></div>
		</div>
	</div>
</ng-template>
